import api from '../api/client';

export async function recordFlowConsent(documentIds, refreshPendingConsents) {
  if (!documentIds?.length) return;
  await api.legal.acceptConsent({ documentIds });
  if (refreshPendingConsents) {
    await refreshPendingConsents();
  }
}
